import Skeleton from 'react-loading-skeleton';
import cx from 'classnames';
import { ui } from 'ui/styles';

import 'react-loading-skeleton/dist/skeleton.css';
import s from './styles.module.scss';

export const FormSkeleton = () => {
  return (
    <div className={cx(ui.containerBody, s.formSkeletonContent)}>
      <Skeleton height={50} inline />
      <div />
      <Skeleton height={50} inline />
      <Skeleton height={50} inline />

      <div>
        <Skeleton className={s.buttonSkeleton} height={40} width="40%" inline />
        <Skeleton height={40} width="40%" inline />
      </div>
    </div>
  );
};
